// Re-export from shared @repo/env package
export { getEnv } from '@repo/env/index'
